import router from "src/routes/routes";
import { CommonAPIService } from "./commonHandler";

const api = new CommonAPIService(router);
const BASE = "/api/supportStrategies";

export const supportStrategiesService = {
  createSupportStrategy: (data) => api.postCall(BASE, data),
  getSupportStrategy: (id) => api.getCall(`${BASE}/${id}`),
  getSupportStrategiesForClient: (clientId) => api.getCall(`${BASE}/client/${clientId}`),
  getClientServiceCodes: (clientId) =>
    api.getCall(`${BASE}/client/${clientId}/service-codes`),
  updateSupportStrategy: (id, data) => api.putCall(`${BASE}/${id}`, data),
  deleteSupportStrategy: (id) => api.deleteCall(`${BASE}/${id}`),
  downloadSupportStrategyPdf: (id) => api.getBlobCall(`${BASE}/${id}/pdf`),
  generateDocument: (id) => api.postCall(`${BASE}/${id}/generate-document`),
  emailSupportCoordinator: (id, data) => api.postCall(`${BASE}/${id}/email`, data),
};
